var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCwc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#ffeff0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(476.198 191.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9844",
    "data-name": "Path 9844",
    d: "M16.6,30.973a8.782,8.782,0,0,1-6.248-2.59,1.768,1.768,0,0,1,2.5-2.5,5.43,5.43,0,0,0,7.5,0l10-10a5.3,5.3,0,1,0-7.5-7.5l-5,5a1.768,1.768,0,1,1-2.5-2.5l5-5a8.838,8.838,0,0,1,12.5,12.5l-10,10a8.783,8.783,0,0,1-6.25,2.59Z",
    transform: "translate(8.866 0)",
    fill: "#c3504f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9845",
    "data-name": "Path 9845",
    d: "M12.136,36.576a8.833,8.833,0,0,1-6.25-15.083l10-10a9.052,9.052,0,0,1,12.5,0,1.768,1.768,0,1,1-2.5,2.5,5.43,5.43,0,0,0-7.5,0l-10,10a5.3,5.3,0,1,0,7.5,7.5l5-5a1.768,1.768,0,1,1,2.5,2.5l-5,5a8.817,8.817,0,0,1-6.248,2.583Z",
    transform: "translate(0 7.722)",
    fill: "#c3504f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCwc);
export default __webpack_public_path__ + "static/media/cwc.a836c5cd7660aca722d21d4fd52739b5.svg";
export { ForwardRef as ReactComponent };